<script setup>
import { ref, onMounted } from "vue";

</script>

<template>
    <!-- start main app area-->
    <div class="app">
        <router-view></router-view>
    </div>
    <!-- end main app area-->
</template>
